export function haveArrayContentsChanged(prevArray = [], currentArray = []) {
    if (prevArray.length !== currentArray.length) {
        return true;
    }
    for (let i = 0; i < prevArray.length; i++) {
        if (prevArray[i] !== currentArray[i]) {
            return true;
        }
    }
    return false;
}
export function hasArrayChanged(prevArray = [], currentArray = []) {
    return (prevArray.length !== currentArray.length || prevArray.some((item, index) => !Object.is(item, currentArray[index])));
}
//# sourceMappingURL=array.js.map